import React from 'react';
import {Paper, Tab, Tabs} from "material-ui";
import {rainfallWarning} from "../../libs/config";

export default class LatestObservation extends React.Component {

  waterLevelTable = (waterLevel) => (
    <table className='table table-striped myTable'>
      <tbody>
      <tr>
        <td>Date</td>
        <td>{waterLevel.data.datetime}</td>
      </tr>
      <tr>
        <td>{waterLevel.data.value.split(':')[0]}</td>
        <td>{waterLevel.data.value.split(':')[1]}</td>
      </tr>
      <tr>
        <td>Trend</td>
        <td>{waterLevel.trend} <span
          className={waterLevel.trend === 'RISING' ? 'glyphicon glyphicon-arrow-up' : waterLevel.trend === 'FALLING' ? 'glyphicon glyphicon-arrow-down' : ''}/>
        </td>
      </tr>
      <tr>
        <td>Status</td>
        <td>{waterLevel.status} <span
          style={{color: waterLevel.status === 'Danger' ? 'red' : 'orange'}}
          className={waterLevel.status !== 'BELOW WARNING LEVEL' && 'glyphicon glyphicon-warning-sign'}/>
        </td>
      </tr>
      </tbody>
    </table>
  );

  rainfallTable = rainfall => {
    const checkStatus = (item) => {
      if(item.value === null){
        return <td> - </td>
      } else {
        if(item.value > rainfallWarning[item.interval]){
          return <td style={{color:'coral'}}>
            {item.value} mm
            <span style={{color: 'coral', marginLeft: '5px'}} className='glyphicon glyphicon-warning-sign'/>
          </td>
        } else {
          return <td>{item.value} mm</td>
        }
      }
    };

    return(
      <table className='table table-striped myTable'>
        <tbody>{
          rainfall.averages.map((item, i) => (
            <tr key={i}>
              <td>{`${item.interval} hours`}</td>
              {checkStatus(item)}
            </tr>
          ))
        }</tbody>
      </table>
    );
  };

  render() {
    let {waterLevel, rainfall, mobView} = this.props;

    if(mobView) return(
      <div>
        <Paper zDepth={2} style={{height:'220px'}}>
          <Tabs>{waterLevel &&
          <Tab label='Latest Water Level'>
            {this.waterLevelTable(waterLevel)}
          </Tab>}{rainfall &&
          <Tab label='Latest Rainfall'>
            {this.rainfallTable(rainfall)}
          </Tab>}
          </Tabs>
        </Paper>
        <br/>
      </div>
    );

    return (
      <div className="inline-it">
        {waterLevel &&
        <Paper zdepth={1} style={rainfall?{width:'49%', marginLeft:'-1%'}:{width:'100%'}}>
          <h5 className='myTableHead'>Latest Water Level</h5>
          <div style={{padding: '0 5px 0 5px'}}>
            {this.waterLevelTable(waterLevel)}
          </div>
        </Paper>}
        {rainfall &&
        <Paper zdepth={1} style={waterLevel?{width:'49%', marginRight:'-1%'}:{width:'100%'}}>
          <h5 className="myTableHead">Latest RainFall</h5>
          <div style={{padding: '0 5px 0 5px'}}>
            {this.rainfallTable(rainfall)}
          </div>
        </Paper>}
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Station/LatestObservation.js